import { FirestoreConverter } from '../../converter';
import { Game } from '../game.class';

/**
 * The converter instance from / to player instance
 */
export const GameConverter: FirestoreConverter<Game> = {
    fromFirestore: (snapshot: any, options: any): Game => {
        const data = snapshot.data(options);
        return Object.assign(new Game(), {
            _id: data.id,
            _name: data.name,
            _description: data.description,
            _logo: data.logo,
            _icon: data.icon,
            _cover: data.cover,
            _format: data.format,
            _ub_version: data.ub_version,
            _gamepadURL: data.gamepadURL,
            _screenURL: data.screenURL,
            _numberOfPlayers: data.numberOfPlayers,
            _playTime: data.playTime,
            _video: data.video,
            _translation: data.translation,
        });
    },
    toFirestore: (game: Game): any => ({
        id: game.id,
        name: game.name,
        description: game.description,
        logo: game.logo,
        icon: game.icon,
        cover: game.cover,
        format: game.format,
        ub_version: game.ubVersion,
        gamepadURL: game.gamepadURL,
        screenURL: game.screenURL,
        numberOfPlayers: game.numberOfPlayers,
        playTime: game.playTime,
        video: game.video,
        translation: game._translation,
    }),
};
